import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createBookmark, removeBookmark } from 'components/Pages/Settings/actions.js';
import { StyledMenuItem } from 'components/Global/Card/styled.js';
import { StyledBookmarkIcon } from './styled.js';

class BookmarkContentButton extends Component {
  select(e) {
    e.preventDefault();
    const { bookmarked } = this.props;

    if (bookmarked) {
      this.props.removeBookmark();
      this.props.setLocalBookmark(false);
    } else {
      this.props.bookmark();
      this.props.setLocalBookmark(true);
    }
  }

  render() {
    const { bookmarked } = this.props;
    return (
      <StyledMenuItem selected={bookmarked} onClick={e => this.select(e)}>
        <StyledBookmarkIcon selected={bookmarked} />
      </StyledMenuItem>
    );
  }
}

const mapDispatchToProps = (dispatch, { id }) => ({
  bookmark: () => dispatch(createBookmark(id)),
  removeBookmark: () => dispatch(removeBookmark(id)),
});

export default connect(null, mapDispatchToProps)(BookmarkContentButton);
